
import { Component, Vue } from 'vue-property-decorator';
import { checkReservationClient, doneReservationClient } from '@/api/reservationClient';

@Component({
  components: {
  },
})
export default class extends Vue {
  mounted() {
    this.checkReservationClient();
  }

  private loading = true;

  private reserveClient = {
    uid: '',
    reservationCode: '',
    useDate: '',
    endDate: '',
    startTime: '',
    endTime: '',
    storeName: '',
    itemName: '',
    createDate: '',
    paymentDate: '',
    paymentType: '',
    people: 0,
    paymentStatus: false,
    doneStatus: false,
  }

  private checkReservationClient() {
    if (!this.$route.query.code) {
      this.$message.error('잘못된 접근입니다.');
      this.$router.push({ name: 'Business' });
    }
    checkReservationClient(this.$route.params.uid, { code: this.$route.query.code }).then((res) => {
      this.reserveClient = res.data;
      this.loading = false;
    }).catch(() => {
      this.$message.error('잘못된 접근입니다.');
      this.$router.push({ name: 'Business' });
    });
  }

  private handleClickDone() {
    this.$confirm('정말 예약을 사용완료 처리하시겠습니까?', '사용완료 처리', {
      confirmButtonText: '예',
      cancelButtonText: '취소',
      type: 'error',
    }).then(() => {
      doneReservationClient(this.$route.params.uid).then(() => {
        this.$message.success('사용완료 처리되었습니다.');
        this.$router.push({ name: 'Business' });
      });
    });
  }
}
